module.exports = __webpack_public_path__ + "img/company-highlight-04.0ab75471.jpg";